import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function PersonalQuote() {
  return <section className="w-full py-24 px-4 bg-[#111] border-y border-white/5 relative overflow-hidden" data-id="element-238">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-239" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-241">
          <Quote className="w-12 h-12 text-[#D4AF37]/40 mb-8" data-id="element-242" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-playfair text-xl sm:text-2xl md:text-3xl text-gray-200 leading-relaxed italic" data-id="element-243">
          "Cada vez que alguien me confía su historia, siento el peso de esa
          confianza. No es algo que tomo a la ligera. Cuando me sentás frente a
          tu pedido, no estoy simplemente haciendo un trabajo — estoy
          conectándome con tu energía, tu historia, tus miedos y tus esperanzas.
          Cada palabra que escribo en tu informe viene de un lugar de genuino
          cuidado. No uso plantillas. No copio y pego. No delego. Cada pedido es
          único porque cada persona es única. Y eso es exactamente lo que hace
          que este trabajo sea tan especial para mí. Después de más de una
          década haciendo esto, todavía me emociono cuando una clienta me
          escribe para decirme que finalmente encontró la paz que buscaba. Ese
          momento hace que todo valga la pena."
        </motion.p>
      </div>
    </section>;
}